import { AssignTransferToTripFolderInput } from '../../lib/types/models/trip-folder/trip-folder-input'
import { IdInput } from '../../lib/types/utils'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

type Input = AssignTransferToTripFolderInput & {
  tripFolderTransferTripBookingId: number
}

export function assignTransferToTripFolder(data: IdInput<Input>) {
  const { id, ...rest } = data

  return restApiClient.url(constructApiUrl(API.tripFolder.assignTransfers.url, { id })).post(rest)
}
